/**
 * Validation chips for a ticket (Backlog 057).
 *
 * A validation ticket (types 30-39) is a creator's own to-do on an adventure, not a complaint, so
 * it gets a "Validation: <label>" chip that tells it apart from reports in a mixed queue. The item
 * key (e.g. `cover`, `coords`, `access`) is what the item is about, stable across importer
 * re-runs; it is shown whenever the ticket carries one. Renders nothing for an ordinary ticket.
 */

import { Chip } from '@mui/material'
import { TicketType, TicketTypeLabels, isValidationTicketType } from '@api/types/tickets'

interface TicketValidationChipsProps {
  type: TicketType
  itemKey?: string | null
}

export function TicketValidationChips({ type, itemKey }: TicketValidationChipsProps) {
  const isValidation = isValidationTicketType(type)
  if (!isValidation && !itemKey) return null

  return (
    <>
      {isValidation && (
        <Chip
          label={`Validation: ${TicketTypeLabels[type] ?? 'Item'}`}
          size="small"
          color="info"
          variant="outlined"
          sx={{ maxWidth: '100%' }}
        />
      )}
      {itemKey && (
        <Chip
          label={`Item: ${itemKey}`}
          size="small"
          variant="outlined"
          sx={{ maxWidth: '100%', fontFamily: 'monospace' }}
          title={itemKey}
        />
      )}
    </>
  )
}
